import React from 'react';
import style from './index.module.scss';
import Header from './Header';
import LeftMenu from './MenuV2';
import AlarmEvents from './AlarmEvents'

class Page extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div className={style['wrapper']}>
                <AlarmEvents />
                <div className='scroll_wrapper'>
                    <div className='content'>
                        <div className="left">
                            <LeftMenu />
                        </div>
                        <div className="right">
                            <Header />
                            <div className="content">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Page;
